export default __webpack_public_path__ + "static/media/Badminton Hall, PKL4.af0bd8e3.jpg";